import AuthenticationProvider from "@Providers/Authentication.provider";

import { Toaster } from "react-hot-toast";
import "../App/Localization/i18n";
import { DialogsProvider } from "@toolpad/core/useDialogs";
import QueryProvider from "@Providers/Query.provider";
import { LicenseInfo } from "@mui/x-license";
import ThemeProvider from "@Providers/Theme.provider";

export const App = () => {
  LicenseInfo.setLicenseKey(
    "b7db80be2bfec457d6a8e40c51c0cb90Tz05OTk5OSxFPTE5MTU1NTU1NjMwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
  );

  return (
    <ThemeProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            // border: "1px solid",
            padding: "8px",
            gap: "8px",
          },
          success: {
            style: {
              borderColor: "#61d345",
            },
          },
        }}
      />
      <DialogsProvider>
        <AuthenticationProvider>
          <QueryProvider />
        </AuthenticationProvider>
      </DialogsProvider>
    </ThemeProvider>
  );
};
